import { DOCUMENTS } from '../../constants/requerimentDocuments';
import { Channels } from '@/core/constants/channelConstants';

export default {
  //when channel is PR and is an update
  applies(context, taxRegimes) {
    return (
      context.isUpdate &&
      context.taxRegime === taxRegimes.INDIVIDUAL.value &&
      context.channel === Channels.WHOLESALER &&
      context.isPromissoryNote
    );
  },
  fields() {
    return {
      [DOCUMENTS.PROMISSORY_NOTE.value]: DOCUMENTS.PROMISSORY_NOTE,
      [DOCUMENTS.SUBSCRIBER_ID.value]: DOCUMENTS.SUBSCRIBER_ID,
      [DOCUMENTS.GUARANTOR_ID.value]: DOCUMENTS.GUARANTOR_ID,
      [DOCUMENTS.SUBSCRIBER_ADDRESS.value]: DOCUMENTS.SUBSCRIBER_ADDRESS,
      [DOCUMENTS.GUARANTOR_ADDRESS.value]: DOCUMENTS.GUARANTOR_ADDRESS,
      [DOCUMENTS.TAX_STATUS_CERTIFICATE.value]:
        DOCUMENTS.TAX_STATUS_CERTIFICATE,
    };
  },
};
